var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPraise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.985 14.76h-5.13a.87.87 0 0 0-.605.243.812.812 0 0 0-.25.584v9.087c0 .219.09.43.25.584a.87.87 0 0 0 .605.242h5.13m0-10.74V25.5m0-10.74L15.26 6.5c.908 0 1.777.348 2.419.968a3.249 3.249 0 0 1 1.002 2.336v2.479h6.615a1.75 1.75 0 0 1 .704.145c.22.096.418.237.578.413.16.176.279.384.35.608.07.224.09.46.057.692l-1.282 9.913a1.636 1.636 0 0 1-.563 1.03c-.31.266-.711.414-1.126.416H10.985"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPraise);
export default __webpack_public_path__ + "static/media/praise.1314f0fd20ef7c8207fe34c576f9a225.svg";
export { ForwardRef as ReactComponent };